// CSS
import '../sass/pages/page.scss'

// === WP ALPHA ASSETS
import '@nematis/wp-alpha/assets/js/page'

// === COMPONENTS
import {
  initHorizontalAutoScroll
} from './components/horizontal-autoscroll'

// Auto-scroll lent des items du bloc Réassurance sur mobile (pages internes type Conciergerie).
// On cible uniquement les blocs Réassurance rendus en mode Bootstrap row (page interne) ;
// le bloc Réassurance HP utilise un layout grid distinct et n'est pas concerné.
const initReinsuranceAutoScroll = () => {
  document
    .querySelectorAll('.reinsurance-block .inner-row-cols-block.row')
    .forEach((el) => initHorizontalAutoScroll(el))
}

if (document.readyState !== 'loading') {
  initReinsuranceAutoScroll()
} else {
  document.addEventListener('DOMContentLoaded', initReinsuranceAutoScroll)
}
